export default {"src":"/_next/static/media/star-sports.0bca271c.svg","height":222,"width":334,"blurWidth":0,"blurHeight":0};